import React, {Fragment} from 'react'
import Alert from './Alert'
import useAlerts from '../hooks/useAlerts'
import {useParams} from 'react-router-dom'
import useBoolState from '../hooks/useBoolState'
import {pluralise} from '../lib/format'

const Section = ({children}) => {
  return (
    <div className='section has-background-filters py-5'>
      <div className='container'>{children}</div>
    </div>
  )
}

export default ({section = false, ownerType, ownerId, types}) => {
  const {organisationID} = useParams()
  const [collapse, setCollapse, toggleCollapse] = useBoolState(true)
  const {alerts, update: updateAlert} = useAlerts(organisationID, ownerType, ownerId, types)

  const handleClearAlert = (e, alertId) => {
    e.preventDefault()
    updateAlert({id: alertId, state: 'cleared'})
  }

  if (alerts.length === 0) return null

  const Wrapper = section ? Section : Fragment
  const ShowMore = () => {
    const count = alerts.length - 3
    return alerts.length > 3 ? (
      <div className='buttons is-right'>
        <button className='button is-white is-small has-text-weight-bold' onClick={toggleCollapse}>
          <span>
            {collapse ? `Show ${count} more` : `Hide ${count}`} {pluralise(`alert`, count)}
          </span>
        </button>
      </div>
    ) : null
  }

  return (
    <Wrapper>
      {collapse ? (
        <Fragment>
          {alerts.slice(0, 3).map((alert, i) => (
            <Alert
              key={i}
              alert={alert}
              onClear={e => handleClearAlert(e, alert.id)}
              className={i < alerts.length - 1 ? 'mb-2' : ''}
            />
          ))}
          <ShowMore />
        </Fragment>
      ) : (
        <Fragment>
          {alerts.map((alert, i) => (
            <Alert
              key={i}
              alert={alert}
              onClear={e => handleClearAlert(e, alert.id)}
              className={i < alerts.length - 1 ? 'mb-2' : ''}
            />
          ))}
          <ShowMore />
        </Fragment>
      )}
    </Wrapper>
  )
}
